export default {
  SET_NUMBER_OF_AI_GENERATED_BLOCKS: '@WS_EDITOR/BLOCKS/SET_NUMBER_OF_AI_GENERATED_BLOCKS',
};
